/****************************************************
 * Module Name:  viewHTMLModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import React, { Component } from "react";
import { Box, Button, TextField } from "@mui/material";
import Modal from "react-bootstrap/Modal";
import FileCopyRoundedIcon from "@mui/icons-material/FileCopyRounded";
import logo from "../../images/pansuriya.jpg"
import Constants from "../../utility/constants";

export default class ViewHTMLModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      buttonText: 'Copy',
      htmlText: this.props.showTextHTML,
    }
  }

  handleCopy = (message) => {
    navigator.clipboard.writeText(message);
    this.setState({ buttonText: 'Copied' })
  }

  handleClose = () => {
    if (this.props.handleClose)
      this.props.handleClose(this.state.htmlText)
  }

  render() {
    return (
      <Box>
        <Modal show={this.props.show} onHide={() => this.handleClose()} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.showBankDetail ? 'View Bank Detail JSON' : 'View PDF HTML'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Box textAlign='right'>
              <Button
                color="success"
                variant="outlined"
                size="small"
                onClick={() => this.handleCopy(this.state.htmlText)}
                startIcon={<FileCopyRoundedIcon />}
              >
                <b>{this.state.buttonText}</b>
              </Button>
            </Box>
            <TextField
              margin="normal"
              fullWidth
              label={this.props.showBankDetail ? 'Bank Detail JSON' : 'PDF HTML'}
              size="large"
              multiline
              rows={25}
              placeholder={this.props.showBankDetail ? 'Bank Detail JSON' : 'PDF HTML'}
              InputProps={{ readOnly: this.props.readOnly ? this.props.readOnly : true }}
              value={this.state.htmlText}
              onChange={(e) => this.setState({ htmlText: e.target.value })}
            />
          </Modal.Body>
        </Modal>
      </Box>
    )
  }
}